import { render, staticRenderFns } from "./DataDeletion.vue?vue&type=template&id=3f0e5fb8&scoped=true"
import script from "./DataDeletion.vue?vue&type=script&lang=js"
export * from "./DataDeletion.vue?vue&type=script&lang=js"
import style0 from "./DataDeletion.vue?vue&type=style&index=0&id=3f0e5fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0e5fb8",
  null
  
)

export default component.exports